import { SET_SSR } from './types';

export const setSSR = (value: boolean) => {
  return { type: SET_SSR, payload: value };
};
